import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFTextField } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Icon } from '@iconify/react';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';
import { closeCashRegisterSchema } from './validations';
import { defaultValuesForm } from './initial-values';

type Props = {
  current?: any;
  isEdit?: boolean;
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function PopTips({ isEdit = false, onSave, isLoading, current }: Props) {
  const { isOpen } = useCashRegisterContext();
  const { palette } = useTheme();

  const defaultValues = useMemo(
    () => defaultValuesForm(current),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]
  );

  const methods = useForm<any>({
    defaultValues,
    resolver: yupResolver(closeCashRegisterSchema),
  });

  const { reset, handleSubmit, control } = methods;

  const onSubmit = async (data: any) => {
    try {
      await onSave({ ...data });
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if ((isEdit && current) || !isEdit) {
      reset(defaultValues as unknown as Partial<any>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, current]);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: isOpen ? 2 : 0 }}>
        <Icon icon="game-icons:take-my-money" color={palette.primary.main} width={100} />
      </Box>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="tips"
          label="Propina"
          type="number"
          isZero
          placeholder="Nuevo valor"
          control={control}
        />
      </Stack>
      <Stack sx={{ px: 3, gap: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="comment"
          label="Comentarios"
          placeholder="Escribe tipo de propina"
          control={control}
        />
      </Stack>
      <Stack sx={{ justifyContent: 'center', my: isOpen ? 2 : 0 }}>
        <LoadingButton type="submit" variant="outlined" loading={isLoading}>
          Guardar cambios
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
